import JoinOrEdit from 'club/joinButton/JoinOrEdit';

import ClubImage from './ClubImage';

const Club = (props) => {
  const { club } = props;

  return (
    <div className="c7-club">
      {club.image && (
        <div className="c7-club__image">
          <ClubImage club={club} />
        </div>
      )}
      <div className="c7-club__details">
        <h2 className="c7-h2">{club.title}</h2>
        <div
          className="c7-club__details__content"
          dangerouslySetInnerHTML={{
            __html: club.content
          }}
        />
        <JoinOrEdit club={club} />
      </div>
    </div>
  );
};

export default Club;
